<template>
  <component :is="currentComponent"></component>
</template>

<script>
import Corporation from '@/views/choices/types/Corporation.vue';
import Brand from '@/views/choices/types/Brand.vue';
import School from '@/views/choices/types/School.vue';
import Course from '@/views/choices/types/Course.vue';
import Teacher from '@/views/choices/types/Teacher.vue';
import Class from '@/views/choices/types/Class.vue';

export default {
  props: {
    resourceType: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      resoureTypes: ['corporation', 'brand', 'school', 'course', 'teacher', 'class'],
    };
  },
  created() {
    if (!this.resoureTypes.includes(this.resourceType)) {
      this.$logger.debug('[FormChoice] resourceType invalid');
      this.$router.push({ name: 'home' });
    }
  },
  computed: {
    currentComponent() {
      switch (this.resourceType) {
        case 'corporation':
          return 'Corporation';
        case 'brand':
          return 'Brand';
        case 'school':
          return 'School';
        case 'course':
          return 'Course';
        case 'teacher':
          return 'Teacher';
        case 'class':
          return 'Class';
      }

      return '';
    },
  },
  components: {
    Corporation,
    Brand,
    School,
    Course,
    Teacher,
    Class,
  },
};
</script>
